import React from 'react';
import { Container, Card, CardBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPercentage } from '@fortawesome/free-solid-svg-icons';
import footerBg from "./../../assets/footerbg.jpg";

const Reservation = () => {
  const reservations = [
    { category: 'Group B', percentage: '1%' },
    { category: 'Group C posts', percentage: '5%' },
    { category: 'Police Constable', percentage: '20%' },
    { category: 'Forest guard, warder & mining guard', percentage: '10%' }
  ];

  const exemptions = [
    'Police Constables, Forest guards, Warder & mining guard exempted from physical screening test',
    'Ex-Agniveers exempted from CET for appointment to group C posts'
  ];

  return (
    <>
      <div style={{
        backgroundImage: `url(${footerBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '30px 0',
        color: 'white',
        margin: '2%',
        borderRadius: '10px'
      }}>
        <Container>
          <h3 className="fw-bold mb-0 text-center">
            <FontAwesomeIcon icon={faPercentage} className="me-2" />
            Agniveer Reservation
          </h3>
        </Container>
      </div>

      <Container className="py-5">
        <Card className="border-0 mb-4" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
          <div style={{
            background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
            padding: '25px',
            color: 'white'
          }}>
            <h4 className="fw-bold mb-0">
              <FontAwesomeIcon icon={faPercentage} className="me-2" />
              Reservation Details
            </h4>
          </div>
          <CardBody className="p-4">
            <div className="mb-4">
              <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                Government of Haryana has provided reservation in direct recruitment to ex-Agniveers as under:
              </p>
            </div>
            
            <div className="row justify-content-center">
              {reservations.map((item, index) => (
                <div key={index} className="col-md-6 col-lg-3 mb-3 d-flex align-items-stretch">
                  <div 
                    className="p-3 text-center rounded w-100"
                    style={{
                      background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
                      color: 'white',
                      height: '120px',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      boxShadow: '0 4px 15px rgba(22,160,133,0.2)',
                      transition: 'all 0.3s'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = 'scale(1.05)';
                      e.currentTarget.style.boxShadow = '0 8px 25px rgba(22,160,133,0.3)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = 'scale(1)';
                      e.currentTarget.style.boxShadow = '0 4px 15px rgba(22,160,133,0.2)';
                    }}
                  >
                    <h5 className="mb-2 fw-bold">{item.category}</h5>
                    <div className="display-6 fw-bold">{item.percentage}</div>
                  </div>
                </div>
              ))}
            </div>
          </CardBody>
        </Card>

        <Card className="border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
          <div style={{
            background: 'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)',
            padding: '25px',
            color: 'white'
          }}>
            <h4 className="fw-bold mb-0">
              <FontAwesomeIcon icon={faPercentage} className="me-2" />
              Exemptions & Benefits
            </h4>
          </div>
          <CardBody className="p-4">
            <div className="mb-4">
              <h5 className="mb-3" style={{ color: '#8e44ad', fontWeight: '600' }}>Additional Exemptions:</h5>
              <ul className="mb-0" style={{ paddingLeft: '20px' }}>
                {exemptions.map((exemption, index) => (
                  <li key={index} style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem', marginBottom: '10px' }}>
                    {exemption}
                  </li>
                ))}
              </ul>
            </div>
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default Reservation